module.exports = __webpack_public_path__ + "media/heart-bubble-5b57917f.svg";